

export default function queryNode(_ref) {
  var type = _ref.type,
      media = _ref.media,
      support = _ref.support;

  var mediaQuery = media ? '[media="' + media + '"]' : '';
  var supportQuery = support ? '[data-fela-support="true"]' : '';

  return document.querySelector('[data-fela-type="' + type + '"]' + supportQuery + mediaQuery);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-dom/es/dom/connection/queryNode.js
// module id = 1175
// module chunks = 0